import React from 'react';
import { WifiOff, Wifi, AlertCircle, CheckCircle } from 'lucide-react';
import { useOfflineData } from '../hooks/usePWA';

const OfflineIndicator: React.FC = () => {
  const { isOffline, offlineActions } = useOfflineData();

  if (!isOffline && offlineActions.length === 0) {
    return null;
  }

  return (
    <div className="fixed top-20 left-4 right-4 z-50 md:left-auto md:right-4 md:w-80">
      {isOffline ? (
        <div className="bg-red-500 text-white rounded-lg shadow-lg p-4 mb-2">
          <div className="flex items-center">
            <WifiOff className="w-5 h-5 mr-3" />
            <div>
              <h4 className="font-semibold text-sm">Çevrimdışı Mod</h4>
              <p className="text-xs text-red-100">
                İnternet bağlantısı yok. Veriler yerel olarak saklanıyor.
              </p>
            </div>
          </div>
        </div>
      ) : (
        offlineActions.length > 0 && (
          <div className="bg-primary text-white rounded-lg shadow-lg p-4 mb-2">
            <div className="flex items-center">
              <Wifi className="w-5 h-5 mr-3" />
              <div>
                <h4 className="font-semibold text-sm">Senkronizasyon</h4>
                <p className="text-xs text-accent">
                  {offlineActions.length} işlem senkronize ediliyor...
                </p>
              </div>
            </div>
          </div>
        )
      )}
    </div>
  );
};

export default OfflineIndicator;